
<template>
  <div>
      <div style="width:1300px;margin:0 auto;margin-top:100px;">       
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">   
             <p class="mt-2 mb-2 font">
                <img src="../../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
                <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                   商品订单查询
                </span>
               
                <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;margin-right:6px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>

                 <div class="mb-2">
                                
                                  <a class="wuliu" style="float:right;margin-right:20px;text-decoration:underline;" @click="Gologistics()">上传物流信息</a>
                               
                     
                 </div>
              
                  
                <div class="mb-3" style="line-height:24px;">


                              
                                
                                            <div class="fd_r" style="margin-right:80px;">
                                                <date class="picker2"  @changeDate="changeDate2($event)"/>
                                            </div> 
                                            <div class="fd_r ml-3">
                                                 结束时间:
                                           </div>
                                            <div class="fd_r">

                                                <date @changeDate="changeDate1($event)"/>
                                            </div>
                             <div class="fd_r">
                                                    开始时间:
                                            </div>



                </div>
                <div class="mb-3">

                                 <div class="fd_h ml-1">
                                       <input class="input_form-control" type="text" v-model="searchForm.xlh" placeholder="请输入序列号">
                                 </div>
                                  <div class="fd_h ml-1">
                                       <input class="input_form-control" type="text" v-model="searchForm.company" placeholder="请输入客户公司">
                                 </div>
                                  <div class="fd_h ml-1">
                                       <input class="input_form-control" type="text" v-model="searchForm.user" placeholder="请输入客户用户名">
                                 </div>

                                 <div class="fd_h ml-1">
                                            <select v-model="searchForm.gs" class="input_form-control">
                                                          <option value="">请选择公司</option>
                                                          <option v-for="(item,index) in gsList" :key="index" :value="item.bh" v-text="item.name"></option>
                                              </select>
                                 </div>
                                 <div class="fd_h ml-1">
                                            <select  v-model="searchForm.xskf" class="input_form-control">
                                                          <option value="">请选择销售人员</option>
                                                          <option v-for="(item,index) in xskfList" :key="index" :value="item.xskf" v-text="item.xskf"></option>
                                              </select>
                                 </div>
                                   <div class="fd_h ml-1">
                                            <select  v-model="searchForm.ordertype" class="input_form-control">
                                                          <option value="">请选择订单类型</option>
                                                          <option v-for="(item,index) in ordertypeList" :key="index" :value="item.ordertype" v-text="item.lxname"></option>
                                              </select>
                                 </div>
                                  <div class="fd_h ml-1">
                                            <select  v-model="searchForm.orderstate" class="input_form-control">
                                                          <option value="">请选择订单状态</option>
                                                          <option v-for="(item,index) in orderstateList" :key="index" :value="item.value" v-text="item.name"></option>
                                              </select>
                                 </div>
                                 
                                            <div style="float:right">
                                                    <button class="bg-primary button_zi heit mr-3" @click="getClerkStoreGoodsQuery(1)">查询</button>
                               
                                            </div>
                                

                                           
                                 
                                 
                    
                </div>    
            <div v-if="showPage">
                        <table class="table table-striped table-hover" ref="print">
                    <thead>
                      <tr style="white-space: nowrap;" class="text-center">
                        <th>公司</th>
                        <th>采购金额</th>
                        <th>销售金额</th>
                        <th>采购数量</th>
                        <!-- <th>下单时间</th> -->
                        <th>订单类型</th>
                        <th>新序列号</th>
                        <th>用户</th>
                        <th>发展人</th>
                        <th>销售人员</th>
                        <th>客户分组</th>
                        <!-- <th>出票时间</th> -->
                        <th>发货状态</th>
                        <!-- <th>发货单号</th> -->
                        <th>是否包邮</th>
                        <th>订单状态</th>
                        <th style="width:120px;">操作</th>
                        <!-- <th>备注1</th> -->
                        <!-- <th>备注2</th> -->
                        
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in tableData" :key="index" class="text-center">
                              <td class="jz_middle">{{item.company}}</td>
                              <td class="jz_middle">{{item.zje}}</td>
                              <td class="jz_middle">{{item.zsje}}</td>
                              <td class="jz_middle">{{item.zsl}}</td>
                              <!-- <td style="font-weight:500">{{item.inserttime | formatUTC}}</td> -->
                              <td style="font-weight:500">{{item.ordertype}}</td>
                              <td style="font-weight:500">{{item.xlh}}</td>
                              <td style="font-weight:500">{{item.username}}</td>
                              <td style="font-weight:500">{{item.ywy}}</td>
                              <td style="font-weight:500">{{item.xskf}}</td>
                              <td style="font-weight:500">{{item.khfz}}</td>
                              <!-- <td style="font-weight:500">{{item.orderduedate | formatUTC}}</td> -->
                              <td style="font-weight:500">{{item.state}}</td>
                              <!-- <td style="font-weight:500">{{item.orderid}}</td> -->
                              <td style="font-weight:500">{{item.isby}}</td>
                              <td style="font-weight:500">{{item.lystate}}</td>
                              <td id="green_channel">
                                   <a id="green_channel_digg" @click="GetDetails(index,item.orderid,item.ordertype,item.username)">查看详情</a>
                              </td>
                              <!-- <td style="font-weight:500">{{item.mark}}</td> -->
                              <!-- <td style="font-weight:500">{{item.lymark}}</td> -->
                      </tr>
                    
                    </tbody>
                  </table>


                    <div>
                       <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                   </div>
                  
                  
                 
                

 
            </div>
           

                  <div v-else style="width:600px;height:600px;margin:0 auto;position:relative;">

                       <img src="../../../static/images/jz.gif" style="width:100;height:68px;display:block;margin:0 auto;position:absolute;top:37%;left:42%;z-index:10;" alt="">

                        <p style="position:absolute;top:52%;left:37%;font-size:25px;">
                           正在加载数据中......
                        </p>

                  </div>



                <p class="text-center">
                    <img src="../../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                </p>
            

       </div> 
      </div>

    <!-- 详情内容 -->

                     <div class="modal fade" id="myModal1" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div class="modal-dialog modal-lg" role="document">

                                <div class="modal-content" style="width:800px;height:400px;position:relative;top:250px;left:100px;margin-bottom:50px;">
                              
                                <div class="modal-body" style="font-size:20px;position:relative;">
                                      
                                   
                                      <p>
                                           下单时间:
                                      </p>
                                      <p>
                                          {{details.inserttime}}
                                      </p>
                                      <p>
                                          出票时间:
                                      </p>
                                      <p>
                                          {{details.orderduedate}}
                                      </p>
                                      <p>
                                          发货单号:
                                      </p>
                                      <p>
                                          {{details.orderid}}
                                      </p>
                                      <p style="color:red;">
                                          ①备注:
                                      </p>
                                      <p>
                                          {{details.mark}}
                                      </p>
                                      <p style="color:red;">
                                          ②备注:
                                      </p>
                                      <p>
                                          {{details.lymark}}
                                      </p>


                                
                                     
                                      
                                      <div style="text-align:right;position:absolute;right:20px;bottom:20px;">
                                              <button type="button" class="btn btn-primary" data-dismiss="modal"><span aria-hidden="true"></span>确认</button>
                                      </div>
                               </div>
                            </div>
                           
                        </div>
                    </div>

                         
                   

                <div>
                  <transition name='fade'>
                           <loading v-show="isLoading">
                                                
                           </loading>
                  </transition>
                </div>
     </div>
</template>
<script>
import vPagination from "../../components/Pagination.vue"
import Loading from '../../components/Loading.vue'
import date6 from '../../components/Date/Date6.vue'
import date from '../../components/Date.vue'
import { async } from 'q';
export default {
      name: 'SaleQuery',
    data () {
      return {
        searchForm: {
          //supplierNum:"",
         DateMoreThan: '',
          DateLessThan: '' ,
            DateLessThan1: '',
          DateMoreThan1: '',// 今天+1
          xlh:"",
          company:"",
          user:"",
          gs:0,
          xskf:"",
          ordertype:0,
          orderstate:"",
        },//搜索内容
        gsList:[],
        xskfList:[],
        ordertypeList:[],
        orderstateList:[{value:"",name:"全部"},{value:"挂账",name:"挂账"},{value:"记账",name:"记账"},{value:"过期",name:"过期"},{value:"作废",name:"作废"}],
        isLoading: false,
        tableData: [],
        excelData:[],
        thisYearData:[],
        lastYearData:[],
        wclv:[],
        details:{},
        Record:'',//总记录数
        Pcount:'',//总页数
        PageNo:1, //当前页码
        showPage:false,
        details:[],
        totalLimitMoney:'',
        toTalAmount:'',
        lToTalAmount:'',

           total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数

      }
    },
    components:{
        vPagination,
        Loading,
        date6,
        date,
    },
    computed:{
         
},
filters: {
  //过滤器时间转换
  //时间转换
      formatUTC:function(utc_datetime) {
          return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        } ,
     
        state:function(state){
            if(state==2)
            {
              return "限制结算50万"
            }
            else{
               return ""
            }
        },
        status:function(status){
          if(status==-1){
            return "删除"
          }
          else
          {
            return ""
          }
        },

         company:function(item) {
               if(item==0){
                   return "医药商城"
               }
               else if(item==1){
                   return "汉宁"
               }
               else if(item==2){
                   return "工业"
               }
               else if(item==3){
                   return "西药"
               }
               else if(item==4){
                   return "新特药"
               }
               else if(item==5){
                   return "药品"
               }
               else if(item==6){
                   return "药材"
               }
               else if(item==8){
                   return "连锁药房"
               }
               else if(item==9){
                   return "器材"
               }
         },


        
},

methods: {

     //跳转物流信息
       Gologistics(){
                   this.$router.push({path:'/logistics'})
       },
         

         //查看详情
          GetDetails: async function(index,orderid,ordertype,username){
                this.details = this.tableData[index]
                this.details.inserttime=this.details.inserttime.replace(/T/ig,"  ").substring(0,20)
                this.details.orderduedate=this.details.orderduedate.replace(/T/ig,"  ").substring(0,20)
                  // const { data: res } =await this.$http.post('Dls/GetShopOrderDetail', {
                  //       action: 'GetShopOrderDetail',
                  //       obj: JSON.stringify({
                  //          orderid:orderid,
                  //          ordertype:ordertype,
                  //          username:username,
                  //       }) 
                  //       })
                  //       console.log(res)
                  $('#myModal1').modal(); 
             
          },

      pagechange:function(currentPage){
         

           this.getClerkStoreGoodsQuery(currentPage);
        
     },


      
     //获取订单类型

      GetOrderType: async function(){
               const { data: res } = await this.$http.post('Dls/GetOrderType', {
          action: 'GetOrderType',
          obj: JSON.stringify({
           
          }) 
        })
        // console.log(res)
        if(res.isok){
             this.ordertypeList=res.data
        }
      },
   
     //获取销售人员
      GetXsUser: async function(){
               const { data: res } = await this.$http.post('Dls/GetXsUser', {
          action: 'GetXsUser',
          obj: JSON.stringify({
           
          }) 
        })
        // console.log(res)
        if(res.isok){
            this.xskfList=res.data

        }
      },

      //获取公司
      GetCompany: async function(){
               const { data: res } = await this.$http.post('Dls/GetCompany', {
          action: 'GetCompany',
          obj: JSON.stringify({
           
          }) 
        })
        // console.log(res)
        if(res.isok){
            this.gsList=res.data

        }
      },
      
           //导出查询
      exportExcel() {
                 const that=this
                require.ensure([], async () => {
                  const { export_json_to_excel } = require('../../Excel/Export2Excel');//注意这个Export2Excel路径
                  const tHeader = ["开始时间","结束时间","公司","今年销售额","去年销售额","查询的今年总的销售","查询的去年总的销售","完成率"]; // 上面设置Excel的表格第一行的标题
                  const filterVal = ['t1','t2','brachNo', 'amount','lAmount','p1','p2','wl']; // 上面的index、nickName、name是tableData里对象的属性key值
                  that.excelData= JSON.parse( JSON.stringify( that.tableData ) ) //深拷贝
                  // [].concat(that.tableData)
                  // [...that.tableData]

                  that.excelData.unshift({t1:that.searchForm.DateMoreThan,t2:that.searchForm.DateLessThan})
                  that.excelData.push({p1:that.toTalAmount,p2:that.lToTalAmount})
                  that.excelData.forEach((item)=>{
                       item.wl=((item.amount/item.lAmount)*100).toFixed(2)+"%"
                        if(item.brachNo==0){
                          item.brachNo="医药商城"
                        }
                        else if(item.brachNo==1){
                            item.brachNo= "汉宁"
                        }
                        else if(item.brachNo==2){
                            item.brachNo= "工业"
                        }
                        else if(item.brachNo==3){
                            item.brachNo= "西药"
                        }
                        else if(item.brachNo==4){
                            item.brachNo= "新特药"
                        }
                        else if(item.brachNo==5){
                            item.brachNo= "药品"
                        }
                        else if(item.brachNo==6){
                            item.brachNo= "药材"
                        }
                        else if(item.brachNo==8){
                            item.brachNo= "连锁药房"
                        }
                        else if(item.brachNo==9){
                            item.brachNo= "器材"
                        }
                        // console.log(item.brachNo)
                     })
                  //  console.log(that.excelData)
                  const list = that.excelData;

                  const data = that.formatJson(filterVal, list);
                  export_json_to_excel(tHeader, data, '销售汇总');//最后一个是表名字
                })
              },
              formatJson(filterVal, jsonData) {
			  
                return jsonData.map(
                    v => filterVal.map(
                      j => v[j]
                      )
				           )
              },



       // 获取当前时间，day为number，getDay(-1):昨天的日期;getDay(0):今天的日期;getDay(1):明天的日期;【以此类推】
              getFirstDay(){
                            var today = new Date();　
                            var tYear = today.getFullYear();　　
                            var tMonth = today.getMonth();　　
                            tMonth = this.doHandleMonth(tMonth + 2);
                          //  console.log(tMonth)
               
                          this.searchForm.DateMoreThan=""+ tYear + tMonth + "01";    
              },
              getYearDay(){
				 var today = new Date();　
				  var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
				  tMonth = this.doHandleMonth(tMonth + 1);
				   this.searchForm.DateLessThan =""+tYear  + "01" + "01";
			},
             
            getDay(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear+"-" + tMonth+"-" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
               getDay1(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                　　
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear + "" + tMonth + "" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
  
     //动态绑定时间
      changeDate1:function(date){
         this.searchForm.DateLessThan=date
         this.searchForm.DateLessThan1=date;
        },
      changeDate2:function(date){
        let year=new Date(new Date(date).getTime()+24*60*60*1000).getFullYear();

        let month=new Date(new Date(date).getTime()+24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(date).getTime()+24*60*60*1000).getDate();
        // console.log(time_date)
        let time;
             if(month<10){
                      if(time_date<10)
                       time=''+year+"-"+"0"+month+"-"+'0'+time_date;
                      else{
                        time=''+year+"-"+"0"+month+"-"+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=''+year+"-"+month+"-"+"0"+time_date;
                     }
                     else{
                       time=''+year+"-"+month+"-"+time_date;
                     }
                  }

          this.searchForm.DateMoreThan=time;
        //   console.log(time)
          this.searchForm.DateMoreThan1=date;
      },   

      searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.Search();
         }
      },

    
  
      getClerkStoreGoodsQuery: async function (PageIndex) {



         //获取三个月前的时间戳   时间条件适合才可以查询
        const that = this
        let  threeMonth=that.getDay(-3*30);

        let  threeMonthTime=new Date(threeMonth).getTime()

        let  today=that.getDay(0);
        let  todayTime=new Date(today).getTime();

        let  select=that.searchForm.DateLessThan1;

        let  select1=that.searchForm.DateMoreThan1;
        let  seTime=new Date(select).getTime();

        let  seTime2=new Date(select1).getTime();
    //    console.log(seTime2)
        let ces=that.searchForm.DateLessThan;
         let a=ces.slice(0,4)+"-"+ces.slice(4,6)+"-"+ces.slice(6,9)
        // console.log(a)
        let ces1=that.searchForm.DateMoreThan;
        let b=ces1.slice(0,4)+"-"+ces1.slice(4,6)+"-"+ces1.slice(6,9)
        // console.log(b)
        let cesTime=new Date(a).getTime();
        // console.log(cesTime)
        let cesTime2=new Date(b).getTime();
        // console.log(cesTime2)
        if(cesTime>=cesTime2){
          alert("开始日期要小于结束日期")
        }
        else{

          // if((threeMonthTime<=seTime&&seTime<=todayTime) 
          // && (threeMonthTime<=seTime2&&seTime2<=todayTime)
          // ){

          // this.isLoading=true;
        const { data: res } = await that.$http.post('Dls/GetShopOrder', {
          action: 'GetShopOrder',
          obj: JSON.stringify({
             PageIndex:PageIndex,
             pageIndex:PageIndex,
             company:that.searchForm.company.trim(),
             starttime:that.searchForm.DateLessThan,
             endtime:that.searchForm.DateMoreThan,
             ordertype:that.searchForm.ordertype,
             state:that.searchForm.orderstate,
             gs:that.searchForm.gs,
             user:that.searchForm.user.trim(),
             xlh:that.searchForm.xlh.trim(),
             xskf:that.searchForm.xskf.trim(),
          }) 
        })
        console.log(res)
           if(res.isok){
                const obj=res.data
                that.tableData = obj.rows
                that.total = obj.record
                that.toTalAmount = obj.toTalAmount
                that.lToTalAmount = obj.lToTalAmount
                if(that.tableData.length>0)
                {
                  that.showPage=true;
                }
                else{
                  that.showPage =false;
                }
                //   that.getSaletotalbyyear()
             
           }

          //  }
          // else{
          //   alert("请选择三个月以内的时间进行查询,查询日期不大于当天")
          // }

        }
         
      },

  
    },
     mounted(){
    },
     created () {
        this.GetCompany()
        this.GetXsUser()
        this.GetOrderType()
      this.searchForm.DateMoreThan=this.getDay(1)
    
      this.searchForm.DateLessThan=this.getDay(0)
   
      this.searchForm.DateLessThan1=this.getDay(-1)
      this.searchForm.DateMoreThan1=this.getDay(0)
        this.getClerkStoreGoodsQuery(1);
        
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.font_yz{
  font-size:1px;
  color:red;
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .heit{
    height:35px;
    width:50px;
  }
  .span_close:hover{
       color:#3190e8;
 }
 
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
 }
 .bj_red{
     color:red;
 }
 .fd_h{
     float: left;
 }
 .fd_r{
     float: right;
 }
 .input_form-control {
/* // display: block;  */
width: 100%; 
height: 35px; 
padding: 6px 12px; 
font-size: 14px; 
line-height: 1.428571429; 
color: #555555; 
vertical-align: middle; 
background-color: #ffffff; 
border: 1px solid #cccccc; 
border-radius: 4px; 
-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
-webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
} 
.input_form-control:focus { 
border-color: #66afe9; 
outline: 0; 
-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
}
.input_form-control:disabled{
    border: 1px solid #DDD;
    background-color: #F5F5F5;
    color:#ACA899;opacity: 1;
}
#green_channel #green_channel_digg {
    background-color: #007bff;;
    border-radius: 5px;
}
#green_channel a:link, #green_channel a:visited, #green_channel a:active {
    color: #fff !important;
    border: none !important;
}
#green_channel a {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAkCAYAAABIdFAMAAAAGXRFW…99ZOdcZGvt4mJjzMVKqcha68iIePB86GAiOv8CDADlIUQBs7MD3wAAAABJRU5ErkJggg%3D%3D) repeat-x;
    display: inline-block;
    padding: 3px 8px;
    color: #fff;
    text-decoration: none;
    font-weight: bold;
    cursor: pointer;
    margin-right: 10px;
    text-shadow: 0 -1px 1px rgba(0,0,0,.25);
    vertical-align: middle;
}
.wuliu{
  color:#36d!important;
  font-size:15px;
}
.wuliu:hover{  
    color:#d2dd33!important;
    cursor: pointer;
}
 
</style>


// WEBPACK FOOTER //
// src/pages/manager/OrderInquiry.vue